import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Icon from "../../components/core_component/icon";
import Core from "../../common/clientSdk";
import { useNavigate } from "react-router-dom";
import {
  CustomText,
  FallBack,
  FallBackBtn,
  PrimaryCta,
} from "../../components";
import CreateCollectionList from "./collectionList";
import CreateCollectionModal from "./createCollection";
import Utils from "../../common/utils";
import { Loader } from "../loader";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const customStylesModal = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "var(--general-secondary-color)",
    borderColor: "var(--gray-gray-50)",
    textAlign: "center",
    zIndex: "5",
    minHeight: "70%",
    height: "70%",
    display: "flex",
    flexDirection: "column",

    paddingLeft: 20,
    width: "600px",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.86)",
    zIndex: 10,
  },
};

const CreateCollectionGrid = ({
  closeModal,
  campaignId,
  orgId,
  brandId,
  onSelectCollection,
}) => {
  const [collectionList, setCollectionList] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(false);
  const [collectionId, setCollectionId] = useState("");
  const [collectionData, setCollectionData] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getCollectionList();
  }, []);
  console.log('orgIdasdf', orgId);

  function getCollectionList() {
    const params = {
      org_id: orgId,
    };
    Core.getCollectionList(
      getCollectionListSuccess,
      getCollectionListFailed,

      (status) => setLoading(status),
      params
    );
  }

  function getCollectionListSuccess(response_data) {
    setCollectionId(response_data?.collection_list[0].collection_id);
    setCollectionData(response_data?.collection_list[0]);
    setCollectionList(response_data.collection_list);
    if (response_data?.collection_list?.length == 0) {
      openModalCollection();
    }
  }

  function getCollectionListFailed(errorList) {
    console.error("Failed to fetch collections", errorList);
  }
  function selectCollection(collection) {
    setCollectionId(collection.collection_id);
    setCollectionData(collection);
  }

  function onSelectCollectionSuccess() {
    closeModalCollection();
    onSelectCollection(collectionData);
    closeModal();
  }

  // function collectionInfluencerPage(collection_id) {
  //   navigate(`/collection/${orgId}/${brandId}/${collection_id}`);
  // }

  const openModalCollection = () => {
    if (modalIsOpen == false) {
      setModalIsOpen(true);
    } else {
      setModalIsOpen(false);
    }
  };

  const closeModalCollection = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      <Modal
        isOpen={true}
        onRequestClose={closeModal}
        style={customStylesModal}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            background: "#ffffff",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 54,
          }}
        >
          <div onClick={closeModal} className="close-btn-icon">
            <Icon iconName="CloseRoundButtonIcon" />
          </div>

          <CustomText
            p
            text={"Collections"}
            textColor={"text_color_primary"}
            fontSize={"font_size_2xl"}
            className="typographyH7"
          />
        </div>
        <div className="collection-grid-card-container">
          {isLoading ? (
            <Loader />
          ) : (
            <>
              {collectionList.length == 0 ? (
                <div className="small-fallback-container">
                  <FallBackBtn
                    heading={"Oops!! you don't have any collection"}
                    title={
                      "You can add your shortlisted influencers in collections, so that you can share them with anyone and get feedback"
                    }
                    widthIcon={100}
                    heightIcon={100}
                    onClick={openModalCollection}
                    text={"Create Collection"}
                  />
                </div>
              ) : (
                <>
                  <div className="collection-grid-container">
                    {collectionList.map((collection, index) => (
                      <div
                        key={index}
                        className={
                          collectionId !== collection.collection_id
                            ? "collection-grid-card"
                            : "collection-grid-card-active"
                        }
                        onClick={() => {
                          selectCollection(collection);
                        }}
                      >
                        <div className="collection-grid-card-name">
                          <CustomText
                            p
                            text={collection.collection_name}
                            className="width-200 Caption-3"
                          />
                          {/* <CustomText
                    p
                    text={collection.collection_name}
                    fontSize={"font_size_regular"}
                    textColor={"text_color_black"}
                    textAlign={"text_align_left"}
                  /> */}
                        </div>
                        <div className="collection-grid-date">
                          <CustomText
                            p
                            text={`Created on:`}
                            className="width-200  typographyH5"
                          />
                          <CustomText
                            p
                            text={Utils.convertUnixToDate(
                              collection.date_added
                            )}
                            //  fontSize={"font_size_tag"}
                            textColor={"text_color_gray"}
                            className="caption_2_10"
                            // textAlign={"text_align_left"}
                          />
                        </div>
                      </div>
                    ))}
                  </div>{" "}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      paddingTop: 20,
                    }}
                  >
                    <button
                      style={{ color: "#090a14" }}
                      className="confirm-btn-bid "
                      onClick={openModalCollection}
                    >
                      Create
                    </button>
                    <div className=" m-l-32">
                      <PrimaryCta
                        fifth
                        onClick={() => onSelectCollectionSuccess()}
                        fontSize={"font_size_large"}
                        className="collection-create-btn"
                        text={"Select Collection"}
                        // isLoading={props.isLoading}
                        disabled={!collectionId}
                      />
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </Modal>
      {modalIsOpen && (
        <CreateCollectionModal
          closeModal={closeModalCollection}
          getCollectionList={getCollectionList}
          campaignId={campaignId}
          org_id={orgId}
          brand_id={brandId}
        />
      )}
    </>
  );
};

export default CreateCollectionGrid;
